// extracted by mini-css-extract-plugin
module.exports = {"content":"Security_content__hhV0K","ef-box":"Security_ef-box__x27bd"};